import Cookies from "js-cookie";
export async function fetchAutoRefresh(url: string, options: any = {}) {
  // read token from localStorage
  let accessToken = Cookies.get("accessToken");

  // fetch original URL with Bearer token
  let res = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (res.status === 401) {
    //Attempt to refresh the access token using the refresh token stored in HttpOnly cookie
    const refreshResponse = await fetch("/api/auth/refresh", {
      method: "POST",
      credentials: "include", // sends the HttpOnly refresh-token cookie
    });

    const data = await refreshResponse.json();

    if (refreshResponse.ok && data.accessToken) {
      Cookies.set("accessToken", data.accessToken);

      // Retry the original request with the new access token
      res = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${data.accessToken}`,
        },
      });
    } else {
      throw new Error("Session expired. Please log in again.");
    }
  }
  return res;
}
